import React from "react";
import { TerminalSquare } from "lucide-react";

const Logo = () => {
    return (
        <div className="flex items-center gap-2">
            <TerminalSquare size={28} className="text-emerald-400" />
            <span className="text-xl tracking-tight">
                <span className="font-bold text-white">Diego</span>
                <span className="font-normal text-zinc-500">.dev</span>
            </span>
        </div>
    );
};

export default Logo;
